import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import PageLoader from "../../../../../../components/PageLoader";
import { useNavigate, useParams } from "react-router-dom";
import { accountLedgers } from "../../../../../../redux/account-ledgers/action";
import { selectAccountLedgersListItems } from "../../../../../../redux/account-ledgers/selector";
import Table from "../../../../../../common/components/table-manager/v1.1/table";

const ManagementAccountsLedgers = () => {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const parmas: any = useParams()
    const [pageData, setPageData] = useState(1)
    const [pageSize, setPageSize] = useState(10);
    const accountledgersItems = useSelector(selectAccountLedgersListItems)
    const [columnDefs, setColumnDefs] = useState({});
    const createColumnDefs: any = () => {
        setColumnDefs([
            {
                field: 'Sl',
                sortable: false,
                filter: false,
                isSortLabel: true,
                headerName: 'Sl',
                cellRenderer(params: any) {
                    return parseInt(
                        params.node.id,
                        10
                    ) + 1;
                },
            },
            { field: 'LedgerName', headerName: 'Ledger Name',searchField: 'LedgerName', sortable: true, filter: true, filterType: 'text' },
            { field: 'AccountCategoryName', headerName: 'Ledger Category', searchField: 'AccountCategoryName', sortable: true, filter: true, filterType: 'text' },
            { field: 'EntityType', headerName: 'Entity Type', searchField: 'EntityType', sortable: true, filter: true, filterType: 'text' },
            { field: 'EntityName', headerName: 'Entity Name', searchField: 'EntityName', sortable: true, filter: true, filterType: 'text' },
            { field: 'CreatedOnUtc', headerName: 'Created On', isDateValueFormat: true },
            { field: 'ModifiedOnUtc', headerName: 'Modified On', isDateValueFormat: true }
        ]);
    }

    const fetchAccountsLedgersList = () => {
        dispatch(accountLedgers.list({
            url: `https://fms.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/e-applications/accounts/ledgers/fetch`,
            entity: 'accountLedgers',
            jsonData: {
                "PageNumber": pageData,
                "PageSize": pageSize,
                "SortField": "Id",
                "SortOrder": "desc",
            }
        }));
    }

    useEffect(() => {
        createColumnDefs()
        fetchAccountsLedgersList()
    }, [pageData,pageSize])

    const handleAdd = () => {
        navigate(`${0}`)
    }

    const handleDelete = (data: any) => {
        dispatch(accountLedgers.delete({
            url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/accounts/ledgers/delete`,
            entity: 'accountLedgers',
            jsonData: {
                Records: [
                    {
                        Id: data?.Id
                    }
                ]
            }
        })).then(() => {
            fetchAccountsLedgersList()
        });
    }
    const handleEdit = (data: any) => {
        navigate(`/management/e-applications/accounts/ledger/${data?.LedgerId}`)
      }
      const handleReloadData = () => {
        fetchAccountsLedgersList()
      }
      const additionButtons: any = [
        {
          svg:
            <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
              <title>Add Ledgers</title>
              <path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="2" fill="none" />
            </svg>,
          callback: () => handleAdd(),
        },
        
        {
          svg:
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
              <title>Reload this table</title>
              <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>,
          callback: () => handleReloadData(),
        },
      ];
    
      const handleSearch = (data: any) => {
        let searchCriteria = {};
        if (data?.column) {
          searchCriteria = [{
            FieldName: data?.column,
            FieldText: data?.column,
            FieldType: 'text',
            FilterOperatorId: 6,
            FieldValue: data?.value
          }]
        } else {
          searchCriteria = [{
            FieldName: "LedgerName",
            FieldText: "LedgerName",
            FieldType: 'text',
            FilterOperatorId: 6,
            FieldValue: data?.value
          }]
        } 

        dispatch(accountLedgers.list({
            url: `https://fms.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/e-applications/accounts/ledgers/fetch`,
            entity: 'accountLedgers',
            jsonData: {
                "PageNumber": pageData,
                "PageSize": pageSize,
                "SortField": "Id",
                "SortOrder": "desc",
                "Searches": searchCriteria,
              }
        }));
    }
    // const additionButtons: any = [
    //     {
    //         name: 'Add Ledgers',
    //         callback: () => handleAdd(),
    //     }
    // ];

    return (
        <>
            {accountledgersItems?.isLoading ?
                <PageLoader /> :
                <Table 
                checkboxConfig={{
                  allowMultiSelect: true,
                  defaultSelectedIds: [],
                  isDisabled: false,
                  keyColumn: 'Id',
                }}
                columnData={columnDefs} rowData={accountledgersItems?.result?.items} setPageData={setPageData}
                setPageSize={setPageSize} paginationData={accountledgersItems?.result?.pagination}
                enableFilter={true} onSearch={handleSearch} additionButtons={additionButtons} onEdit={handleEdit} onDelete={handleDelete}
                headingName="Ledgers" />
            }
        </>
    );
};

export default ManagementAccountsLedgers;
